<template>
  <div>
    <div v-if="loading" class="blackbox-loader"></div>

    <div v-if="!loading && valid == false" class="form-wrapper">
      <div class="content-boxje">
        <!-- Match het ID?  -->
          <div class="survey-wrapper">
            <v-card-title class="py-0" style="font-size:18px; font-weight:500;">Sessie onjuist</v-card-title>
            <v-card-text>Deze is sessie is niet geldig!</v-card-text>
          </div>
      </div>
    </div>


        <!-- Match het ID?  -->
        <!-- <template>
          <v-card class="content-wrapper">
            <v-card-title class="py-0" style="font-size:18px; font-weight:500;">Sessie verlopen</v-card-title>
            <v-card-text>Deze is sessie is verlopen.</v-card-text>
          </v-card>
        </template>-->
        <v-card v-if="!loading && valid"  outlined max-width="700px" style="margin: 30px auto">
          <v-card-text>
            <div class="logo">
              <v-img aspect-ratio="1" :src="logoUrl">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
            <p class="py-1 ma-0 text-center">
              <strong>{{docSurvey.clientName}}</strong>, heeft recent de volgende punten achtergelaten.
            </p>
            <p class="pa-2 ma-0 text-center" style="font-size:38px; font-weight:600;">{{averageScore}}</p>
            <p class="pb-2 ma-0 text-center">Gemiddelde score</p>
            <p class="py-1 ma-0 text-center"><strong>Behandeld op: </strong>{{ docSurvey.dateSend.seconds | moment("D MMMM YYYY") }}</p>
            <p class="pb-2 ma-0 text-center"><strong>Geholpen door: </strong>{{ docSurvey.clientLastTreatmentByName }}</p>
            <p class="pa-2 ma-0 text-center caption grey lighten-5"> Let op: Dit zijn de huidige beoordeelde vragen van {{ docSurvey.clientName }}</p>

            <v-list v-for="(questions, index) in docSurvey.surveyQuestions" :key="questions + index">

              

                <!-- <v-list three-line v-for="(questions, index) in docSurvey.surveyQuestions" :key="questions + index" v-if="questions.rating || questions.feedback"> -->
              <v-list-item v-if="questions.rating" @click="moreFeedback(0, questions.question[language], questions.rating )">
                

                <v-list-item-avatar size="60px">
                  <v-img
                    v-if="questions.rating == 5"
                    src="https://pillarrr.io/images/icons/rating-icon-super.png"
                    aspect-ratio="1"
                    >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>

                  <v-img
                    v-if="questions.rating == 4"
                    src="https://pillarrr.io/images/icons/rating-icon-goed.png"
                    aspect-ratio="1"
                    >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>

                  <v-img
                    v-if="questions.rating == 3"
                    src="https://pillarrr.io/images/icons/rating-icon-voldoende.png"
                    aspect-ratio="1"
                    >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>

                  <v-img
                    v-if="questions.rating == 2"
                    src="https://pillarrr.io/images/icons/rating-icon-onvoldoende.png"
                    aspect-ratio="1"
                    >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>

                  <v-img
                    v-if="questions.rating == 1"
                    src="https://pillarrr.io/images/icons/rating-icon-slecht.png"
                    aspect-ratio="1"
                    >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>


                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle><span style="font-size: 12px; color: rgba(0,0,0,0.54);">Beoordeeld op {{ questions.dateUpdated.seconds | moment("D MMM YYYY - HH:mm") }}u</span></v-list-item-subtitle>
                  <v-list-item-title v-text="questions.question[language]"></v-list-item-title>
                  <v-list-item-subtitle style="color: rgba(0,0,0,0.78); font-style: italic;" v-if="questions.feedback" >"{{questions.feedback }}"</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon
                    v-if="questions.rating <= docSurvey.pointofverdictRating"
                    color="grey lighten-1"
                  >thumb_down</v-icon>
                </v-list-item-action>
              </v-list-item>

              <!-- <v-list-tile
                @click="moreFeedback(1, questions.question[language], questions.feedback )"
                v-if="questions.feedback"
              >
                <v-list-tile-action>
                  <v-icon color="grey lighten-1">subject</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="questions.question[language]"></v-list-tile-title>
                  <v-list-tile-subtitle>{{questions.feedback }}</v-list-tile-subtitle>
                </v-list-tile-content>
              </v-list-tile> -->
            </v-list>
            <div align="center">
              <v-btn large :href="'mailto:' + clientEmail" dark :color="companyPrimaryColor" rounded>Direct reageren</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </div>


</template>
<style scoped>
.page-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
}
.logo {
  margin: 22px auto;
  width: 120px;
}
.divider {
  border-top: 1px #e8e9ee solid;
  padding: 0 0 12px 0;
  margin: 0 14px;
}
.form-wrapper {
  position: absolute;
  background-color: #f6f7fb;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0;
}
.content-wrapper {
  width: 460px;
  margin: 0 auto;
  background-color: #fff;
  border: 1px #e8e9ee solid;
  border-radius: 5px;
  overflow: hidden;
  padding: 8px 0 14px 0;
}
h1 {
  font-size: 18px;
  font-weight: 500;
}

@media only screen and (max-width: 370px) {
}
</style>
<script>
import moment from "moment";
import firebase from "firebase/app";;
import db from "../firebase/init";
import _ from "lodash";
export default {
  components: {},
  name: "Clientrating",
  props: ["surveyID"],
  // Company, Passthru activeBranch router
  // :8080/clientchange?id=xSgweWdgfdsgfd
  data: () => ({
    loading: true,
    docSurvey: {},
    language: null,
    pointofverdictRating: null,
    clientEmail: null,
    averageScore: null,
    logoUrl: null,
    valid: null
  }),
  created() {
    this.loadSpecificSurvey();
  },
  methods: {
    loadSpecificSurvey() {
      this.loading = true;
      db.collection("surveys")
        .doc(this.surveyID)
        .get()
        .then(doc => {
          console.log(doc.data(), doc.id);
          this.docSurvey = doc.data();
          this.docSurvey.id = doc.id;
          this.language = doc.data().clientLanguage;
          this.pointofverdictRating = doc.data().pointofverdictRating;
          this.clientEmail = doc.data().clientEmail;
          this.logoUrl = doc.data().logoUrl;
        })
        .then(() => {
          this.docSurvey.surveyQuestions = _.orderBy(
            this.docSurvey.surveyQuestions,
            ["order"],
            ["asc", "desc"]
          );
          let countSum = null;
          let totalratingpoints = null;
          for (
            let index = 0;
            index < this.docSurvey.surveyQuestions.length;
            index++
          ) {
            if (this.docSurvey.surveyQuestions[index].rating) {
              countSum++;
              totalratingpoints +=
                this.docSurvey.surveyQuestions[index].rating * 2;
            }
          }
          this.averageScore = (totalratingpoints / countSum).toFixed(1);
          this.valid = true;
          this.loading = false;
        })
        .catch(error => {
          this.valid = false;
          console.error("Error document: ", error);
          this.loading = false;
        });
    },
    moreFeedback(typeRating, titlefeed, feedback) {
      //typeRating 0 = rating feedback smileys. 1 = geschreven feedback
      if (typeRating === 0) {
        this.$swal({
          title: `${titlefeed}`,
          html: `${smiley()} <br>
          <span align="center">Beoordeling: ${feedback}</span>`,
          confirmButtonText: "Sluiten",
          confirmButtonColor: "black"
        });
        function smiley() {
          if (feedback == 5) {
            return "<img src='https://pillarrr.io/images/icons/rating-icon-super.png'>";
          }
          if (feedback == 4) {
            return "<img src='https://pillarrr.io/images/icons/rating-icon-goed.png'>";
          }
          if (feedback == 3) {
            return "<img src='https://pillarrr.io/images/icons/rating-icon-voldoende.png'>";
          }
          if (feedback == 2) {
            return "<img src='https://pillarrr.io/images/icons/rating-icon-onvoldoende.png'>";
          }
          if (feedback == 1) {
            return "<img src='https://pillarrr.io/images/icons/rating-icon-slecht.png'>";
          }
        }
      } else {
        this.$swal({
          title: `${titlefeed}`,
          text: `${feedback}`,
          confirmButtonText: "Okay",
          confirmButtonColor: "black"
        });
      }
    }
  },
  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
  }
};
</script>